/* istanbul ignore file */

import 'core-js/stable';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import Inspect from 'inspx';

import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { apolloClient } from './common/apollo';

import AdManager from 'lib/ad-manager';
import TrackingPixel from 'lib/tracking-pixel';
import reportWebVitals from 'lib/reportWebVitals';
import { WebViewBridgeProvider } from 'lib/web-view-bridge';

import './common/mobile-polyfill';
import './common/resizeObserver-polyfill';
import './common/iframe-bridge';
import SetupSentry from 'components/SetupSentry';
import AuthProvider from 'components/AuthProvider';
import { AdServiceProvider } from 'modules/advertisement/components/Provider';
import GrowthBookProvider from 'components/GrowthBookProvider';
import { ClassroomFeaturesProvider } from 'components/ClassroomFeaturesContext';
import { env } from 'utils/env';

ReactDOM.render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <HelmetProvider>
          <BrowserRouter>
            <WebViewBridgeProvider>
              <GrowthBookProvider>
                <SetupSentry />
                <TrackingPixel />
                <AdManager>
                  <AdServiceProvider>
                    <ClassroomFeaturesProvider>
                      <Inspect disabled={env.STAGE === 'prod'}>
                        <App />
                      </Inspect>
                    </ClassroomFeaturesProvider>
                  </AdServiceProvider>
                </AdManager>
              </GrowthBookProvider>
            </WebViewBridgeProvider>
          </BrowserRouter>
        </HelmetProvider>
      </AuthProvider>
    </ApolloProvider>
  </StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
